import type { ProcessesResponse } from 'types';

export type SortKey = 'created' | 'emailInitiator' | 'flowType' | 'processStatus' | 'name' | 'updated';
export type SortDirection = 'asc' | 'desc';
export type Bucket = 'all' | 'active' | 'done' | 'expired' | 'cancelled';
export type EntityFilter = '' | 'person' | 'company';

export const DEFAULT_DATA: ProcessesResponse[] = [];

export const SEARCH_DEBOUNCE_MS = 400;
export const RX_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const BUCKET_STATUS = {
	all: 'admin_tab_all',
	active: 'admin_tab_active',
	done: 'admin_tab_done',
	expired: 'admin_tab_expired',
	cancelled: 'admin_tab_cancelled'
} as const;

export const fields = ['agreementProcessId', 'processKennitala', 'initiatorsKennitala'];

export const defaultParams = {
	agreementProcessId: '',
	initiatorsKennitala: '',
	processKennitala: '',
	resultLimit: 4_000,
	refresh: 0
};

export type AdminTableColumn = keyof ProcessesResponse;

export const columns: AdminTableColumn[] = [
	'agreementProcessId',
	'kennitala',
	'kennitalaInitiator',
	'emailInitiator',
	'fullNameInitiator',
	'phoneInitiator',
	'flowType',
	'processStatus',
	'created',
	'modified'
];
